import React from "react";
import { useLocation } from "react-router-dom";
import { isNativeStoreApp } from "../lib/appMode";

function findHeaderShell() {
  const candidates = Array.from(document.querySelectorAll("#root > div"));
  return (
    candidates.find((element) => {
      if (!(element instanceof HTMLElement)) return false;
      if (element.classList.contains("ga-settings-backdrop")) return false;
      const style = window.getComputedStyle(element);
      return style.position === "fixed" && Number(style.zIndex || 0) >= 1000;
    }) || null
  );
}

export default function NativeAppChromeController() {
  const location = useLocation();

  React.useEffect(() => {
    if (!isNativeStoreApp()) return undefined;

    const body = document.body;
    const feedRoute = String(location.pathname || "") === "/feed";
    body.classList.toggle("ga-native-feed-route", feedRoute);
    body.classList.remove("ga-native-feed-header-hidden");

    let header = null;
    let observer = null;
    let lastY = Math.max(0, window.scrollY || 0);
    let ticking = false;

    const tagHeader = () => {
      const nextHeader = findHeaderShell();
      if (nextHeader === header) return;
      header?.classList.remove("ga-native-header-shell");
      header = nextHeader;
      header?.classList.add("ga-native-header-shell");
    };

    const update = () => {
      ticking = false;
      if (!feedRoute) return;

      const currentY = Math.max(0, window.scrollY || 0);
      const delta = currentY - lastY;

      if (currentY < 90 || delta < -7) {
        body.classList.remove("ga-native-feed-header-hidden");
      } else if (currentY > 150 && delta > 7) {
        body.classList.add("ga-native-feed-header-hidden");
      }

      lastY = currentY;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    tagHeader();
    observer = new MutationObserver(tagHeader);
    observer.observe(document.getElementById("root") || document.body, {
      childList: true,
      subtree: true,
    });

    if (feedRoute) {
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("touchmove", onScroll, { passive: true });
    }

    return () => {
      observer?.disconnect();
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("touchmove", onScroll);
      header?.classList.remove("ga-native-header-shell");
      body.classList.remove("ga-native-feed-route");
      body.classList.remove("ga-native-feed-header-hidden");
    };
  }, [location.pathname]);

  return null;
}
